export default "/img/icon-lending.svg"